import { motion } from 'framer-motion';
import { ExternalLink, ShieldAlert } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { SectionHeading } from './SectionHeading';
import { OVERSEAS_FAQ, LINZ_5M_URL, fadeUp } from './data';

export const OverseasBuyers = () => (
  <section id="overseas" className="py-20 md:py-28 bg-[#1a1e1a]" data-testid="overseas-buyers-section">
    <SectionHeading eyebrow="Information for overseas buyers">Buying in New Zealand</SectionHeading>

    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <motion.div {...fadeUp}>
        <Accordion type="single" collapsible className="border-t border-white/15">
          {OVERSEAS_FAQ.map((item, i) => (
            <AccordionItem key={item.q} value={`q${i}`} className="border-white/15" data-testid={`overseas-info-${i}`}>
              <AccordionTrigger className="text-left text-white text-base md:text-lg font-light py-5 hover:no-underline hover:text-[#d6cdb4]" data-testid={`overseas-q-${i}`}>
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/80 text-sm md:text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>

      <motion.div {...fadeUp} className="mt-8">
        <a
          href={LINZ_5M_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="linz-guidance-link"
          className="inline-flex items-center gap-2 text-[#d6cdb4] text-sm tracking-[0.12em] uppercase border-b border-[#d6cdb4]/60 pb-1 hover:text-white hover:border-white transition-colors"
        >
          LINZ guidance — residential land over NZ$5M
          <ExternalLink size={14} />
        </a>
      </motion.div>

      <motion.aside {...fadeUp} className="mt-12 bg-white/[0.04] border-l-2 border-[#c8bfa8] p-7 md:p-9" data-testid="visa-disclaimer">
        <div className="flex items-center gap-3 mb-4">
          <ShieldAlert size={18} className="text-[#d6cdb4]" />
          <p className="text-[#d6cdb4] text-xs tracking-[0.2em] uppercase">Visa disclaimer</p>
        </div>
        <p className="text-white/80 text-sm leading-relaxed">
          Buying The 126 does not meet the Active Investor Plus visa investment requirement and does not
          guarantee any visa or Overseas Investment Office consent. Visa decisions are made by Immigration
          New Zealand and consent decisions by the Overseas Investment Office (LINZ). This information is
          general, reflects published guidance as at 2026, may change, and is not legal or immigration
          advice. Take independent advice from a New Zealand lawyer and a licensed immigration adviser
          before entering into any agreement.
        </p>
      </motion.aside>
    </div>
  </section>
);
